const Bstats = [
    { number: "25+", label: "Years Experience" },
    { number: "200+", label: "Projects Completed" },
    { number: "50+", label: "Team Members" },
    { number: "10", label: "Awards Won" }
];


export default Bstats;